import { MAX_FILE_SIZE } from '../constants/fileUploadsConstants';
export const fileExceedsSizeLimit = file => {
  return file.size > MAX_FILE_SIZE;
};